import { Component, Input } from '@angular/core';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-sidebar-header',
    imports: [IconComponent],
    templateUrl: './sidenav-header.component.html',
    styleUrl: './sidenav-header.component.scss'
})
export class SidebarHeaderComponent {
  @Input() collapsed!: boolean;
  @Input() title!: string;
}